import * as React from 'react';

import ConfirmForgotPasswordCtrl from '@webapp/controllers/registration/confirm-forgot-password';

interface ForgotPasswordFinishPageProps {
  account: string | null;
  className?: string;
}

export const ForgotPasswordFinishPage: React.FC<
  ForgotPasswordFinishPageProps
> = (props) => (
  <section className={props.className}>
    {props.account ? (
      <ConfirmForgotPasswordCtrl username={props.account} />
    ) : null}
  </section>
);

export default ForgotPasswordFinishPage;
